$('.actions a[data-event="action"]').on('click', function () {
    switch ($(this).data('type')) {
        case 'toggle':
            $('.actions').setDataAttribute('collapsed', !$('.actions').data('collapsed'));
            break;
    }
});
